import {action, observable, runInAction, makeObservable} from 'mobx';
import {decorate, inject, injectable} from '@yosmanyga/di';
import {DeviceManager, Dispatcher} from '@yosmanyga/base';
import {AbstractDeviceIdentifier, DeviceIdentifier,} from '@yosmanyga/abstract-device-identifier';
import {DeviceApi} from '../data';

class AppDeviceController {
    loaded: boolean;
    device: string | null;

    constructor(
        private dispatcher: Dispatcher,
        private deviceManager: DeviceManager,
        private deviceIdentifier: DeviceIdentifier,
        private deviceApi: DeviceApi
    ) {
        this.loaded = false;

        this.device = null;

        // this.dispatcher.register('device_saved', this.listenToLanguageSaved)

        makeObservable(this, {
            loaded: observable,
            device: observable,
            load: action,
            set: action,
            validate: action,
            delete: action,
        });
    }

    load = async () => {
        await this.deviceManager.load();

        const device = this.deviceManager.get();

        runInAction(() => {
            this.device = device;
            this.loaded = true;
        });
    };

    set = async () => {
        const data = await this.deviceIdentifier.identify();

        const device = await this.deviceApi.addDevice(data);

        await this.deviceManager.save(device);

        runInAction(() => {
            this.device = device;
        });
    };

    validate = async (): Promise<boolean> => {
        if (!this.device) {
            throw new Error('Device not set');
        }

        return await this.deviceApi.validateDevice(this.device);
    };

    delete = async () => {
        await this.deviceManager.delete();

        runInAction(() => {
            this.device = null;
        });
    };
}

decorate(injectable(), AppDeviceController);
decorate(inject(Dispatcher), AppDeviceController, 0);
decorate(inject(DeviceManager), AppDeviceController, 1);
decorate(inject(AbstractDeviceIdentifier), AppDeviceController, 2);
decorate(inject(DeviceApi), AppDeviceController, 3);

export {AppDeviceController};
